import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  id: "newMusic"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_HomeListTitle = _resolveComponent("HomeListTitle");

  var _component_MusicList = _resolveComponent("MusicList");

  return _ctx.newMusicList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 最新音乐 "), _createVNode(_component_HomeListTitle, {
    title: "最新音乐",
    routerPath: "/main/latestMusic"
  }), _createVNode(_component_MusicList, {
    musicList: _ctx.newMusicList,
    itemHeight: "58px"
  }, null, 8
  /* PROPS */
  , ["musicList"])])) : _createCommentVNode("v-if", true);
}